var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPrority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    transform: "matrix(1 0 0 -1 0 18)",
    fill: "#FFB952"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.94239L9.53252 11.1224C9.4628 11.1927 9.37985 11.2485 9.28846 11.2866C9.19706 11.3246 9.09903 11.3442 9.00002 11.3442C8.90101 11.3442 8.80298 11.3246 8.71159 11.2866C8.6202 11.2485 8.53724 11.1927 8.46752 11.1224L5.28752 7.94239C5.21723 7.87267 5.16143 7.78972 5.12335 7.69832C5.08528 7.60693 5.06567 7.5089 5.06567 7.40989C5.06567 7.31088 5.08528 7.21285 5.12335 7.12146C5.16143 7.03006 5.21723 6.94711 5.28752 6.87739C5.42804 6.7377 5.61813 6.6593 5.81627 6.6593C6.01441 6.6593 6.2045 6.7377 6.34502 6.87739L9.00002 9.53239L11.655 6.87739C11.7947 6.73883 11.9833 6.66072 12.18 6.65989C12.2787 6.65932 12.3766 6.67824 12.468 6.71556C12.5593 6.75288 12.6424 6.80788 12.7125 6.87739C12.7853 6.9446 12.8441 7.02558 12.8854 7.11563C12.9268 7.20569 12.9498 7.30304 12.9533 7.40207C12.9568 7.5011 12.9406 7.59983 12.9057 7.69257C12.8708 7.78531 12.8179 7.87022 12.75 7.94239Z",
    fill: "#EDF0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrority);
export default __webpack_public_path__ + "static/media/low-prority.73f4d4d203cb63e48b092bab0abb608c.svg";
export { ForwardRef as ReactComponent };